<form class="training-builder" [formGroup]="addForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div id="training-zone-template-builder" *ngIf="isLoaded | async">
      <div mat-dialog-content>
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline" floatLabel="always" class="top-input">
                  <mat-label>Name</mat-label>
                  <input type="text" matInput placeholder="" formControlName="name">
                  <mat-error *ngIf="addForm.controls?.name?.errors?.required">
                    Name is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <app-autocomplate [label]="'Sports'" [form]="addForm.get('sport')" [options]="sports" (optionChange)="onSelectSport()" [showErrorRequired]="addForm.controls.sport.errors?.required"></app-autocomplate>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline" floatLabel="always" class="top-input">
                  <mat-label>Description</mat-label>
                  <textarea rows="5" matInput formControlName="description"></textarea>
                  <mat-error *ngIf="addForm.controls?.description?.errors?.required">
                    Description is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="d-flex flex-wrap slide-toggle-container mt-2 mb-4">
                  <div *ngIf="auth && auth.role.is_owner">
                    <mat-slide-toggle (change)="onChangeDefault($event)" formControlName="isDefault">Use default</mat-slide-toggle>
                  </div>
                  <div *ngIf="auth && auth.role.is_owner">
                    <mat-slide-toggle formControlName="isPublic">Public for all users</mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col"></div>
        </div>
        <div class="builder-rea">
          <div
            cdkDropList
            (cdkDropListDropped)="onZoneDrop($event)"
            class="zones-drop-list"
            formArrayName="zones">

            <div
              *ngFor="let zone of zones.controls; let i = index"
              cdkDrag
              (cdkDragStarted)="onDragStarted()"
              (cdkDragEnded)="onDragEnded()"
              class="zone-drag-container">

              <!-- Drag preview (what shows while dragging) -->
              <div *cdkDragPreview class="zone-drag-preview">
                <div class="preview-content">
                  <mat-icon class="drag-icon">drag_handle</mat-icon>
                  <span>{{zone.get('name')?.value || 'Zone ' + (i + 1)}}</span>
                </div>
              </div>
              <div *cdkDragPlaceholder class="zone-drag-placeholder">
                <div class="placeholder-content">Drop zone here</div>
              </div>

              <fieldset [formGroupName]="i" class="zone-fieldset">
                <!-- Drag handle -->
                <div class="drag-handle" cdkDragHandle>
                  <mat-icon>drag_handle</mat-icon>
                </div>

                <div class="zone-toggle-top" *ngIf="isGermanFederation">
                  <mat-slide-toggle
                    [checked]="zone.get('is_double_master_metric')?.value"
                    (change)="onMasterMetricToggleChange($event, i)"
                    class="master-metric-toggle">
                    <span class="toggle-label-left">Relates to one Master Metric</span>
                    <span class="toggle-label-right">Fraction between two Master Metric</span>
                  </mat-slide-toggle>
                </div>

                <legend>ZONE {{i + 1}}</legend>

                <button type="button" mat-icon-button mat-raised-button (click)="deleteZone(i)" class="close-button">
                  <mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
                </button>

                <div class="builder-column u-margin-top-30" style="flex: 0.75">
                  <mat-form-field class="example-full-width" appearance="outline" floatLabel="always">
                    <mat-label>Name</mat-label>
                    <input type="text" matInput placeholder="" formControlName="name">
                  </mat-form-field>
                </div>

                <div class="builder-column u-margin-top-30" style="flex: 0.25">
                  <mat-form-field class="example-full-width" appearance="outline" floatLabel="always">
                    <mat-label>Code</mat-label>
                    <input type="text" matInput formControlName="code" maxlength="3" placeholder="">
                  </mat-form-field>
                </div>
                <div class="builder-column u-margin-top-30 color-picker-column" style="flex: 0.3">
                  <mat-form-field class="example-full-width" appearance="outline" floatLabel="always">
                    <mat-label>Zone Color</mat-label>
                    <input
                      type="color"
                      matInput
                      formControlName="color"
                      (change)="onZoneColorChange($event, i)"
                      class="color-input">
                  </mat-form-field>
                </div>

                <div class="builder-column ref-sys u-margin-top-30" style="flex: 1.5">
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Ref-Sys</mat-label>
                    <mat-select formControlName="referenceSystem" multiple="true"
                                (selectionChange)="onSelectSystemReferenceChange($event, i)">
                      <mat-option *ngFor="let system of referenceSystems" [value]="system.value">{{system.viewValue}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="builder-column u-margin-top-30" style="flex: 1.25" *ngIf="!isGermanFederation">
                  <app-autocomplate [label]="'Master metric'" [form]="zone.get('master_metric')" [options]="filterMasterMetrics" (optionChange)="onSelectChangeMaterMetric($event, i)" [displayField]="'viewValue'"></app-autocomplate>
                </div>

                <ng-container *ngIf="isGermanFederation && !zone.get('is_double_master_metric')?.value">
                  <div class="builder-column u-margin-top-30" style="flex: 1.25">
                    <app-autocomplate
                      [label]="'Master metric'"
                      [form]="zone.get('master_metric')"
                      [options]="filterMasterMetrics"
                      (optionChange)="onSelectChangeMaterMetric($event, i)"
                      [displayField]="'viewValue'">
                    </app-autocomplate>
                  </div>
                </ng-container>

                <ng-container *ngIf="isGermanFederation && zone.get('is_double_master_metric')?.value">
                  <div class="builder-column u-margin-top-30" style="flex: 0.6">
                    <app-autocomplate
                      [label]="'First Master Metric'"
                      [form]="zone.get('master_metric')"
                      [options]="getDeltaMetrics(i)"
                      (optionChange)="onSelectChangeMaterMetric($event, i)"
                      [displayField]="'viewValue'">
                    </app-autocomplate>
                  </div>

                  <div class="builder-column u-margin-top-30" style="flex: 0.6">
                    <app-autocomplate
                      [label]="'Second Master Metric'"
                      [form]="zone.get('master_metric_additional')"
                      [options]="getDeltaMetrics(i)"
                      [displayField]="'viewValue'">
                    </app-autocomplate>
                  </div>
                </ng-container>

                <div class="value-column" formArrayName="values" style="flex: 2">
                  <div *ngFor="let valueRow of getFormValues(i).controls; let j = index">
                    <div [formGroupName]="j" style="flex-direction: row; display: flex;">
                      <div class="builder-column u-margin-top-30" style="flex: 0.65">
                        <mat-form-field appearance="outline" floatLabel="always">
                          <mat-label *ngIf="currentMetric">Target ({{getCurrentMasterMetric(i)?.unit}})</mat-label>
                          <mat-label *ngIf="!currentMetric">Target</mat-label>
                          <input type="text" matInput placeholder="" formControlName="targetValue">
                        </mat-form-field>
                      </div>
                      <div class="builder-column u-margin-top-30" style="flex: 0.65">
                        <mat-form-field appearance="outline" floatLabel="always">
                          <mat-label *ngIf="currentMetric">Lower ({{getCurrentMasterMetric(i)?.unit}})</mat-label>
                          <mat-label *ngIf="!currentMetric">Lower</mat-label>
                          <input [attr.disabled]="isDisableValue() ? 'disabled' : null" type="text" matInput placeholder="" formControlName="lowerValue">
                        </mat-form-field>
                      </div>
                      <div class="builder-column u-margin-top-30" style="flex: 0.65">
                        <mat-form-field appearance="outline" floatLabel="always">
                          <mat-label *ngIf="currentMetric">Upper ({{getCurrentMasterMetric(i)?.unit}})</mat-label>
                          <mat-label *ngIf="!currentMetric">Upper</mat-label>
                          <input type="text" matInput placeholder="" formControlName="upperValue">
                        </mat-form-field>
                      </div>
                      <div class="u-margin-top-30" style="flex: 1">
                        <div style="flex-direction: row; display: flex">
                          <div style="flex: 1">
                            <app-autocomplate [label]="'Additional Type'" [form]="valueRow.get('addValueSelect')" [options]="addValues" (optionChange)="onSelectChangeAddValue($event, i)" [displayField]="'viewValue'"></app-autocomplate>
                          </div>
                          <div style="flex: 1">
                            <mat-form-field appearance="outline" floatLabel="always">
                              <mat-label>Value ({{getCurrentAddValue(i)}})</mat-label>
                              <input type="text " matInput placeholder="" formControlName="addValueValue">
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="builder-column u-margin-top-30 additional-metrics-output" style="flex: 1.5">
                  <button
                    type="button"
                    mat-stroked-button
                    (click)="openAdditionalMetricsDialog(i)"
                    class="additional-metrics-button line-height-16">
                    <div class="o-flex o-flex--justify-space-between">
                      <mat-icon class="u-padding-right-5">tune</mat-icon>
                      <span>Select metrics to visualize the <br> physiology of this zone ({{ zones.at(i).get('outputValue')?.value?.length || 0 }})</span>
                    </div>
                  </button>
                </div>

                <div class="zone-toggle-bottom" *ngIf="isGermanFederation && isSpeedBasedSport">
                  <mat-slide-toggle
                    [checked]="zone.get('is_speed_toggle')?.value"
                    (change)="onEnergySpeedToggleChange($event, i)"
                    class="master-metric-toggle">
                    <span class="toggle-label-left">Energy</span>
                    <span class="toggle-label-right">Speed</span>
                  </mat-slide-toggle>
                </div>
                <button type="button" mat-raised-button (click)="copyZone(i)" class="copy-zone-button" title="Copy zone">Clone this zone</button>
              </fieldset>
            </div>
          </div>
          <a class="u-background-dark-grey u-margin-top-10 training-builder__add_zone_btn" mat-raised-button (click)="addNewZone()">
            {{ '+ add zone' }}
          </a>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div>
      <button id="cancelButton" mat-raised-button (click)="closeDialog(false)" type="button">  {{ "Cancel" }}</button>
      <button id="saveButton" mat-raised-button color="primary" *ngIf="isEditTemplate()" type="submit">  {{ "Save" }}</button>
    </div>
  </mat-dialog-actions>
</form>
